function evictOldest(map, threshold, count) {
  if (map.size > threshold) {
    var iter = map.keys();
    for (var i = 0; i < count; i++) {
      var key = iter.next().value;
      if (key) map.delete(key);
    }
  }
}
export {
  evictOldest
};
//# sourceMappingURL=evictOldest.js.map
